import React from 'react';

import Logo from '../../../assets/images/prestige_logo_full.png';
import './navbar.css';

function Navbar(props) {
    const { auth } = props;

    return (
        <div className='_navbar'>
            <div className='container'>
                <img 
                    className='logo' 
                    src={Logo}
                    alt='Prestige'
                />
                <i 
                    className=' logoff fas fa-power-off'
                    onClick={() => auth.signOut()}
                ></i>
            </div>
        </div>
    );
}

export default Navbar;